const ROUTE = '/vorstand';
const { pathname } = new URL(window.location.href);
export function initVorstand() {
    if (pathname !== ROUTE)
        return;
    const pictures = document.querySelectorAll('.frame-type-textpic img');
    pictures.forEach(picture => picture.style.borderRadius = '150px');
}
